import React, { useMemo } from "react";
import { Users } from "lucide-react";

import { DashboardCard } from "../DashboardCard";
import { CardHeader } from "../CardHeader";
import { DonutChart, DonutLegend } from "../charts/DonutChart";

import { getEmployeeStatusData } from "../../services/dashboardAnalytics";
import { LIFECYCLE_COLORS } from "../../constants/constants";

export const EmployeeLifecycleCard = React.memo(
  function EmployeeLifecycleCard({
    employees,
    activeStatus,
    onStatusClick,
  }) {
    const lifecycleData = useMemo(
      () => getEmployeeStatusData(employees),
      [employees]
    );

    return (
      <DashboardCard>
        <CardHeader
          icon={Users}
          iconBg="#F5F3FF"
          iconColor="#7C3AED"
          title="Employee Lifecycle"
        />

        <div className="text-xs text-slate-400 font-medium mb-1">
          Employees by Lifecycle Status
        </div>

        <div className="grid grid-cols-2 gap-2 items-center flex-1">
          <DonutChart
            data={lifecycleData}
            colors={LIFECYCLE_COLORS}
            total={employees.length}
            centerLabel="Total"
            onSliceClick={onStatusClick}
            activeKey={activeStatus}
          />

          <DonutLegend
            data={lifecycleData}
            colors={LIFECYCLE_COLORS}
            onSelect={onStatusClick}
            activeKey={activeStatus}
          />
        </div>
      </DashboardCard>
    );
  }
);